import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import Utils from "../../../core/shared/utils";
import { ISOTService } from '../../services';

export interface SimpleMessageDialogConfig {
  /** langkey/langkeys werden mit umbruch/paragraph untereinander ausgegeben */
  langkey: string | string[];
  buttons: SimpleMessageButtonConfig[];
  /** eines der buttons kann als default button markiert werden
   * es kann die position des Button arrays sine oder die referenz auf den button
    */
  default_button?: number | SimpleMessageButtonConfig;
  /** displays the buttons in a row, else in a column */
  buttons_in_row?: boolean;
  sot_service: ISOTService;
}

export interface SimpleMessageButtonConfig {
  langkey: string;
  onClick: (dialog_ref: MatDialogRef<SimpleMessageDialogComponent>) => void;
}

interface SimpleMessageButtonConfigExt extends SimpleMessageButtonConfig {
  /** style defaults to "", "action" = highlight */
  style: "" | "action";
}

const DEFAULT_SIMPLEMESSAGEBUTTONCONFIG: SimpleMessageButtonConfigExt = {
  langkey: "",
  onClick: () => { },
  style: ""
};

@Component({
  selector: "sot-simplemessagedialog",
  templateUrl: "./simplemessagedialog.component.html",
  styleUrls: ["./simplemessagedialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleMessageDialogComponent implements OnInit, OnDestroy {

  public texts: string[] = [];
  public buttons: SimpleMessageButtonConfigExt[] = [];
  public buttons_in_row: boolean = true;
  private _sotService: ISOTService;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<SimpleMessageDialogComponent, any>
    , @Inject(MAT_DIALOG_DATA) public data: SimpleMessageDialogConfig
    , private _coreLogService: CoreLogService) {
    const me = this;
    me._sotService = data.sot_service;

    if (typeof data.langkey === "string") {
      me.texts = [data.langkey];
    } else {
      me.texts = data.langkey;
    }

    me.buttons = data.buttons.map((btn) => ({ ...DEFAULT_SIMPLEMESSAGEBUTTONCONFIG, ...btn }));

    let default_button_index = -1;
    if (!Utils.IsNull(data.default_button)) {
      if (typeof data.default_button !== "number") {
        default_button_index = data.buttons.indexOf(data.default_button);
      } else if (data.default_button >= 0 && data.default_button < me.buttons.length) {
        default_button_index = data.default_button;
      }
    }
    if (default_button_index > -1) {
      me.buttons[default_button_index].style = "action";
    }

    if (!Utils.IsNull(data.buttons_in_row)) {
      me.buttons_in_row = data.buttons_in_row;
    }
  }

  public ngOnInit(): void {
    console.debug("--- sot-simplemessagedialog ngOnInit")
    const me = this;
    me.PushChanges();
  }

  public get isModeOne(): boolean {
    return this.data.sot_service.Accessabilty.useModeOne;
  }

  public get isModeTwo(): boolean {
    return this.data.sot_service.Accessabilty.useModeTwo;
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-simplemessagedialog ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("SimpleMessageDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

}
